import React from "react";
import { PageLayout } from "../../../../components";
import { YourCarConditionHelmet } from "../../../../components/SellHelmets";
import { useSourceSystem } from "../../../../hooks/useSourceSystem";
import useInterior from "./useInterior";
import { RadioAndToolTip } from "../../components/RadioAndToolTip";

export const Interior = () => {
  const {
    answer,
    showAsButtons,
    handleSubmit,
    pageTitle,
    question,
    questionTitle
  } = useInterior();
  const {
    sourceSystem: { getCTAValue }
  } = useSourceSystem();
  const CTALabel = getCTAValue && getCTAValue();

  return (
    <>
      <YourCarConditionHelmet />
      <PageLayout>
        <div>
          <PageLayout.Header
            title="Your car’s condition"
            step={question.stepNo}
          />
        </div>
        <PageLayout.Content backgroundColour="">
          <>
            <h3 className="ch-fs--4">{pageTitle}</h3>
            <p className="ch-fs--3">{questionTitle}</p>
            <RadioAndToolTip
              question={question}
              showAsButtons={showAsButtons}
            />
          </>
        </PageLayout.Content>

        <PageLayout.Footer backgroundColour="" position="">
          <button
            className="ch-btn ch-btn--success ch-display--block ch-mh--auto sm:ch-width--6 md:ch-width--5 ch-width--12 lg:ch-width--4"
            type="button"
            onClick={() => handleSubmit(answer)}
          >
            {CTALabel}
          </button>
        </PageLayout.Footer>
      </PageLayout>
    </>
  );
};
